import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { ClipboardList, PlayCircle, ShieldCheck, CheckCircle2, AlertTriangle, PauseCircle } from 'lucide-react';

export function WorkOrdersKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Lệnh Giao',
      value: 345,
      suffix: 'Lệnh',
      icon: ClipboardList,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [300, 310, 320, 335, 340, 342, 345]
    },
    {
      title: 'Đang Thi Công',
      value: 120,
      suffix: 'Lệnh',
      icon: PlayCircle,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Trên công trường',
      chartColor: 'bg-blue-500',
      chartData: [100, 105, 110, 115, 118, 119, 120]
    },
    {
      title: 'Chờ Nghiệm Thu',
      value: 45,
      suffix: 'Lệnh',
      icon: ShieldCheck,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'QA/QC Check',
      chartColor: 'bg-amber-500',
      chartData: [30, 35, 38, 40, 42, 44, 45]
    },
    {
      title: 'Đã Hoàn Thành',
      value: 165,
      suffix: 'Lệnh',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Đạt chất lượng',
      chartColor: 'bg-emerald-500',
      chartData: [140, 145, 150, 155, 160, 162, 165]
    },
    {
      title: 'Quá Hạn',
      value: 12,
      suffix: 'Cảnh báo',
      icon: AlertTriangle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Giảm 3 lệnh',
      chartColor: 'bg-rose-500',
      chartData: [18, 17, 16, 15, 14, 13, 12]
    },
    {
      title: 'Bị Tạm Dừng',
      value: 3,
      suffix: 'Lệnh',
      icon: PauseCircle,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'neutral',
      trendValue: 'Chờ vật tư/mặt bằng',
      chartColor: 'bg-slate-500',
      chartData: [2, 3, 3, 3, 3, 3, 3]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
